// IE 2026 09 24 / ODOO-… (заказ Игоря: оформление строк в панелях-меню): ОДИН ИСТОЧНИК ПРАВДЫ ОБ ОФОРМЛЕНИИ ПУНКТА ПАНЕЛИ-МЕНЮ ПО СТРОКЕ НАСТРОЙКИ.
// Заказ (24.09, два скрина): «добавь в форме-меню возможность выделения цветом как в примере … применить форматирование ячейки-строки настройки;
// такой же подход … во всех других формах-меню». Пункт панели (MenuPanel.vue) получает то же оформление, что ячейка-строка в гриде настройки,
// из которой он построен: дерево задач стола (doc.data_tasks → панель задач в шапке и вкладка Tasks panel), страницы стола (WORKSPACE.doc.pages →
// панель страниц), виджеты страницы (PAGE.doc.pages → меню страницы и виджеты под страницей в панели страниц); у команд (панели пользователя,
// ≡ виджета, ≡ таблицы) — те же поля определения (style / класс ячейки), если определение их несёт.
// ФАКТ (замер 24.09, запись 2W1_001 dev02 + AttrGrid.vue): кнопки «палитра» формы ячейки (AttrGrid.set_color2 / rowStyle_applyToSelection) пишут
// оформление ячейки в строку грида по пути  _cells.<binding колонки>.fields[0].style  = { 'background-color': '#00ffff', color, 'font-weight', … }
// (у дерева задач колонка «Назва» = binding node.valueStr → row._cells.node.valueStr.fields[0].style); грид (formatItem_cells: styleSrc =
// {...attr_col.style, ...cell_field.style} → e_style.setProperty(prop, val, 'important')) кладёт ЛЮБОЕ свойство inline; второй канал —
// класс ячейки row['cssClass-<binding>'] (addClass); устаревшие поля _cells.<binding>.color / backgroundColor и оформление элемента списка
// row._appearance {color, backgroundColor, style} (elements_appearance) — там же, поверх. Здесь — тот же расчёт, но с БЕЛЫМ СПИСКОМ свойств вида
// (фон, цвет, шрифт, рамка, тень, прозрачность): отступы / размеры ячейки (padding-*) у плашки пункта свои.
// Чистые функции (без стора и DOM): юнит — handoff-files/menu-format-2026-09-24/menuFormat.test.mjs.

export const MENU_FORMAT_BINDING = 'node.valueStr'   // колонка-заголовок строк настроек (дерево задач, страницы стола, виджеты страницы)
export const MENU_FORMAT_TEXT = 'var(--text-color, #495057)'   // цвет текста ячейки грида без своего цвета — под заливкой текст не on-accent и не цвет наведения

// свойства, которые пункт берёт у ячейки: то, что пишут палитра и меню Style грида (rowStyleMenu_attrs: color, background-color, font-size,
// font-weight, border-*), плюс начертание / подчёркивание / тень; padding-* и прочая геометрия ячейки — нет
export const MENU_FORMAT_PROPS = new Set([
    'background', 'background-color', 'background-image',
    'color', 'font-weight', 'font-style', 'font-size', 'font-family', 'font-variant', 'text-decoration', 'text-decoration-line', 'text-decoration-color',
    'text-decoration-style', 'text-transform', 'letter-spacing', 'text-shadow',
    'border', 'border-color', 'border-style', 'border-width', 'border-radius',
    'border-top', 'border-top-color', 'border-top-style', 'border-top-width',
    'border-bottom', 'border-bottom-color', 'border-bottom-style', 'border-bottom-width',
    'border-left', 'border-left-color', 'border-left-style', 'border-left-width',
    'border-right', 'border-right-color', 'border-right-style', 'border-right-width',
    'outline', 'outline-color', 'outline-style', 'outline-width', 'box-shadow', 'opacity',
])

const isObj = (x) => !!(x && typeof x === 'object')
const toKebab = (p) => String(p || '').trim().replace(/[A-Z]/g, m => '-' + m.toLowerCase())

// как mainStore.normalizeStyle: объект → ключи kebab-case, пустые значения выпадают; строка CSS «a: b; c: d» → объект
export function menuFormat_normalizeStyle(style) {
    const out = {}
    if (!style) return out
    if (typeof style === 'string') {
        for (const rule of style.split(';')) {
            const i = rule.indexOf(':')
            if (i < 0) continue
            const prop = rule.slice(0, i).trim(), val = rule.slice(i + 1).trim()
            if (prop && val) out[prop] = val
        }
        return out
    }
    if (isObj(style)) {
        for (const [k, v] of Object.entries(style)) {
            if (v === null || v === undefined || v === '') continue
            out[toKebab(k)] = String(v)
        }
    }
    return out
}

// значение по пути «a.b.c» (как store.get_value для _cells.<binding>: binding колонки сам с точками — node.valueStr)
const getPath = (obj, path) => {
    let cur = obj
    for (const k of String(path || '').split('.')) {
        if (!k) continue
        if (!isObj(cur)) return undefined
        cur = cur[k]
    }
    return cur
}

// оформление ЯЧЕЙКИ строки грида в колонке binding — те же каналы и тот же порядок, что formatItem_cells AttrGrid:
// _cells.<binding>.fields[0].style → устаревшие _cells.<binding>.color / backgroundColor → _appearance элемента списка (color / backgroundColor / style)
export function menuFormat_cellStyle(row, binding = MENU_FORMAT_BINDING) {
    const out = {}
    if (!isObj(row)) return out
    const cell = getPath(row._cells, binding)
    const f0 = (isObj(cell) && Array.isArray(cell.fields)) ? cell.fields[0] : null
    Object.assign(out, menuFormat_normalizeStyle(isObj(f0) ? f0.style : null))
    if (isObj(cell)) {
        if (cell.color) out['color'] = String(cell.color)
        if (cell.backgroundColor) out['background-color'] = String(cell.backgroundColor)
    }
    const app = row._appearance
    if (isObj(app)) {
        if (app.color) out['color'] = String(app.color)
        if (app.backgroundColor) out['background-color'] = String(app.backgroundColor)
        if (isObj(app.style)) for (const k in app.style) if (app.style[k]) out[toKebab(k)] = String(app.style[k])
    }
    return out
}

// класс ячейки строки в колонке binding (канал row['cssClass-<binding>'] грида; у дерева задач так красится колонка Status — cssClass-status)
export function menuFormat_cellClass(row, binding = MENU_FORMAT_BINDING) {
    return isObj(row) ? String(row['cssClass-' + binding] || '').trim() : ''
}

// белый список свойств вида (ключи приводятся к kebab-case, пустые выпадают)
export function menuFormat_filter(style) {
    const out = {}
    if (!isObj(style)) return out
    for (const k in style) {
        const kk = toKebab(k), v = style[k]
        if (!MENU_FORMAT_PROPS.has(kk) || v === null || v === undefined || v === '') continue
        out[kk] = String(v)
    }
    return out
}

// оформление строки настройки в колонке binding → { style (kebab, только свойства вида), cssClass, has }
export function menuFormat_fromRow(row, binding = MENU_FORMAT_BINDING) {
    const style = menuFormat_filter(menuFormat_cellStyle(row, binding))
    const cssClass = menuFormat_cellClass(row, binding)
    return { style, cssClass, has: !!(Object.keys(style).length || cssClass) }
}

export function menuFormat_hasBg(style) {
    return !!(isObj(style) && (style['background-color'] || style['background'] || style['background-image']))
}

// оформление ПУНКТА панели: строка-источник — raw._row (построители панелей кладут строку настройки: tasksPanel_build, AppTopbar.pagesPanelItems),
// иначе сам пункт (меню страницы получает строки PAGE.attrs как есть; определения команд — свои поля); колонка — raw._binding / row._binding,
// иначе node.valueStr; поверх — style самого определения (объект или строка CSS: команда панели может нести своё оформление). opts.on === false —
// выключатель (fe.ux.menuPanelRowFormat) → null. Возвращает null, когда оформления нет (пункт как раньше — без единого inline-свойства)
export function menuFormat_item(raw, opts = {}) {
    if (!isObj(raw) || opts.on === false) return null
    const row = isObj(raw._row) ? raw._row : raw
    const binding = String(raw._binding || row._binding || opts.binding || MENU_FORMAT_BINDING)
    const f = menuFormat_fromRow(row, binding)
    const style = { ...f.style, ...menuFormat_filter(menuFormat_normalizeStyle(raw.style)) }
    if (!Object.keys(style).length && !f.cssClass) return null
    return { style, cssClass: f.cssClass, bg: menuFormat_hasBg(style), binding }
}

// inline-стиль элемента пункта: под заливкой без своего цвета текст — цветом текста ячейки грида (MENU_FORMAT_TEXT), не on-accent текущей страницы и
// не цветом наведения (inline главнее классов); у ТЕКУЩЕЙ страницы без заливки свой цвет текста не ставится — заливка акцентом и on-accent остаются
export function menuFormat_styleFor(fmt, opts = {}) {
    if (!isObj(fmt) || !isObj(fmt.style)) return null
    const style = { ...fmt.style }
    const bg = menuFormat_hasBg(style)
    if (bg && !style.color) style.color = MENU_FORMAT_TEXT
    if (!bg && opts.current) delete style.color
    return Object.keys(style).length ? style : null
}

// относительная яркость и контраст WCAG (для проб и проверок читаемости: «rgb(…)» / «#rrggbb» / «#rgb»)
export function menuFormat_rgb(color) {
    const s = String(color || '').trim()
    let m = s.match(/^#([0-9a-f]{3})$/i)
    if (m) return m[1].split('').map(c => parseInt(c + c, 16))
    m = s.match(/^#([0-9a-f]{6})([0-9a-f]{2})?$/i)
    if (m) return [0, 2, 4].map(i => parseInt(m[1].slice(i, i + 2), 16))
    m = s.match(/^rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)/i)
    if (m) return [+m[1], +m[2], +m[3]]
    return null
}
export function menuFormat_luminance(color) {
    const rgb = menuFormat_rgb(color)
    if (!rgb) return null
    const f = (c) => { const x = c / 255; return x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4) }
    return 0.2126 * f(rgb[0]) + 0.7152 * f(rgb[1]) + 0.0722 * f(rgb[2])
}
export function menuFormat_contrast(a, b) {
    const la = menuFormat_luminance(a), lb = menuFormat_luminance(b)
    if (la === null || lb === null) return null
    const hi = Math.max(la, lb), lo = Math.min(la, lb)
    return (hi + 0.05) / (lo + 0.05)
}

export default { MENU_FORMAT_BINDING, MENU_FORMAT_TEXT, MENU_FORMAT_PROPS, menuFormat_normalizeStyle, menuFormat_cellStyle, menuFormat_cellClass, menuFormat_filter, menuFormat_fromRow, menuFormat_hasBg, menuFormat_item, menuFormat_styleFor, menuFormat_rgb, menuFormat_luminance, menuFormat_contrast }
